<template>
  <div>
    <b-overlay :show="loading" rounded="sm" no-fade>
      <b-row>
        <b-col cols="12">
          <b-card>
            <div class="cs-header-table">
              <div class="custom-search d-flex justify-content-end">
                <b-form-group>
                  <div class="d-flex align-items-center">
                    <label style="width: 100px" class="mr-1">Tìm kiếm</label>
                    <b-form-input
                      v-model="filter"
                      placeholder="Nhập nội dung"
                      type="text"
                      size="sm"
                      class="d-inline-block"
                    />
                  </div>
                </b-form-group>
              </div>
              <b-form-group>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  @click="handle()"
                  class="btn btn-primary"
                >
                  Tạo mới
                </b-button>
              </b-form-group>
            </div>
            <b-table
              :items="fnGetList"
              :fields="fields"
              striped
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              ref="tblList"
              primary-key="id"
              empty-text="Không có dữ liệu"
              table-class="vgt-table cs-table-info"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + (currentPage - 1) * perPage + 1 }}
              </template>
              <template v-slot:cell()="data">
                {{ data.value }}
              </template>

              <template v-slot:cell(action)="data">
                <b-button
                  variant="flat-success"
                  class="btn-icon p-50 m-0"
                  v-b-tooltip.hover.top="'Cập nhật'"
                  @click="handle(data.item)"
                >
                  <i class="fa-solid fa-pencil"></i>
                </b-button>
                <b-button
                  variant="flat-danger"
                  class="btn-icon p-50 m-0"
                  v-b-tooltip.hover.top="'Xóa'"
                  @click="handleDelete(data.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </template>
            </b-table>
            <b-row>
              <b-col md="6">
                <div>
                  Hiển thị
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      style="width: 70px"
                    ></b-form-select
                    >&nbsp;
                  </label>
                  trên tổng số {{ totalRows }} dòng
                </div>
              </b-col>
              <b-col md="6" class="text-right">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-card>
          <modal
            :show-modal.sync="showModal"
            :model="model"
            :reload.sync="reload"
            :name-controller="nameController"
          ></modal>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BCard,
  VBModal,
  BTable,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  CommonGetPagingParams as GetPagingParams,
  CommonDelete as Delete,
} from "@/services/api/Common/CommonService";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Modal from "./ModalCommon";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BOverlay,
    Modal,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  props: ["nameController"],
  data() {
    return {
      loading: true,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      sortBy: "name",
      sortDesc: false,
      filter: null,
      filterOn: [],
      reload: false,
      fields: [
        {
          label: "STT",
          key: "index",
          thStyle: "width:50px",
          class: "text-center",
          // thClass: "text-center",
          // tdClass: "text-center",
        },
        {
          label: "Mã",
          key: "code",
          class: "text-center",
          sortable: true,
        },
        {
          label: "Tên",
          key: "name",
          sortable: true,
        },
        {
          label: "Mã quốc gia",
          key: "qgCode",
          class: "text-center",
          sortable: true,
        },
        {
          label: "#",
          key: "action",
          class: "text-center",
        },
      ],
      numberOfElement: 1,
      totalRows: 1,
      showModal: false,
      model: [],
    };
  },
  watch: {
    reload(val) {
      this.fnRefresh();
    },
  },
  computed: {},
  created() {
    this.fnRefresh();
  },
  methods: {
    async fnRefresh() {
      this.$refs.tblList?.refresh();
    },
    async onPageChange(page = 1) {
      this.currentPage = page;
      const params = {
        start: this.currentPage,
        limit: this.perPage,
      };
      this.$refs.tblList?.refresh();
    },
    fnGetList(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      };
      const postdata = {
        controller: this.nameController,
        data: params,
      };
      this.loading = true;
      try {
        let promise = GetPagingParams(postdata);
        return promise.then((resp) => {
          let items = resp.data.data;
          this.totalRows = resp.data.totalRows;
          this.numberOfElement = resp.data.data.length;
          return items || [];
        });
      } finally {
        this.loading = false;
      }
    },
    handle(value) {
      this.showModal = true;
      if (value == undefined) this.model = {};
      else {
        this.model = JSON.parse(JSON.stringify(value));
      }
    },

    handleDelete(data) {
      this.$bvModal
        .msgBoxConfirm("Dữ liệu đã xóa sẽ không được khôi phục lại!", {
          title: "Bạn chắc chứ?",
          size: "sm",
          okVariant: "primary",
          okTitle: "Xóa",
          cancelTitle: "Hủy",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            const postdata = {
              controller: this.nameController,
              data: data,
            };
            Delete(postdata).then((res) => {
              if (res.isError) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thất bại",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                this.fnRefresh();
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          }
        });
    },
  },
};
</script>
